import React, { useEffect, useState } from "react";
import { addPayment, getTenantByID, updateTenant } from "./apiService";
import { useAuth } from "./auth";
import { useNavigate } from "react-router-dom";

const UpdatePayment = () => {
  const [guestname, setGuestname] = useState("");
  const [mobileno, setMobileno] = useState("");
  const [aadharno, setAadharno] = useState("");
  const [joindate, setJoindate] = useState("");
  const [rentamt, setRentamt] = useState("");
  const [advamt, setAdvamt] = useState("");
  const [balamt, setBalamt] = useState("");
  const [paymentdate, setPaymentdate] = useState("");
  const [paidstatus, setPaidstatus] = useState(false);
  const [errors, setErrors] = useState({});
  const { guestid, roomid, pgid } = useAuth();

  const [balpay, setBalpay] = useState("");
  const navigate = useNavigate();

  useEffect(() => {
    getTenantByID(guestid)
      .then((res) => {
        setGuestname(res.name);
        setMobileno(res.mobileno);
        setAadharno(res.aadharNo);
        setJoindate(res.joinedDate);
        setRentamt(res.rentAmt);
        setAdvamt(res.advAmt);
        setBalamt(res.balAmt);
        setPaidstatus(res.paid);
        setPaymentdate(res.paymentDate);
        setBalpay(res.balAmt);
      })
      .catch((e) => console.log(e));
  }, [guestid]);

  const handlePaymentCancel = () => {
    navigate("/MyDashboard");
  };

  const handlePaymentSubmit = () => {
    let errors = {};
    if (!balpay) errors.balpay = "Please Enter valid Amount";

    let bal = balamt - balpay;
    let date;
    let pstatus;
    let pdate = new Date().toISOString().split("T")[0];

    if (bal <= 0) {
      let pdate = new Date(paymentdate);
      pdate.setMonth(pdate.getMonth() + 1);
      let ndate = pdate.toISOString().split("T")[0];
      date = ndate;
      pstatus = true;
    } else {
      date = paymentdate;
      pstatus = paidstatus;
    }

    // console.log(bal);
    // console.log(pdate);
    // console.log(date);

    setErrors(errors);

    if (Object.keys(errors).length === 0) {
      const tenant = {
        name: guestname,
        mobileno: mobileno,
        aadharNo: aadharno,
        joinedDate: joindate,
        rentAmt: rentamt,
        balAmt: bal,
        advAmt: advamt,
        paymentDate: date,
        paid: pstatus,
        pgname: pgid,
        roomNo: roomid,
      };

      updateTenant(tenant, guestid);

      const payment = {
        pname: guestname,
        paadhar: aadharno,
        pamount: balpay,
        paymentDate: pdate,
        pgname: pgid,
      };

      addPayment(payment);

      setGuestname("");
      setMobileno("");
      setAadharno("");
      setJoindate("");
      setRentamt("");
      setAdvamt("");
      setPaymentdate("");
      setPaidstatus(false);
      navigate("/MyDashboard");
      // changePaymentStatus(false);
    }
  };
  return (
    <div className="container">
      <div className="label">
        Paying Amount:
        <input
          type="text"
          className="inputbox"
          name="payment"
          defaultValue={balpay}
          // value={rooms}
          onChange={(e) => setBalpay(e.target.value)}
        />
        {errors.balpay ? (
          <div className="errortext">{errors.balpay}</div>
        ) : null}
      </div>
      <div className="btnContainer-cls">
        <input
          type="submit"
          className="btn-cls"
          value="Submit"
          onClick={handlePaymentSubmit}
        />
        <input
          type="submit"
          className="btn-cls"
          value="Cancel"
          onClick={handlePaymentCancel}
        />
      </div>
    </div>
  );
};

export default UpdatePayment;
